import { withInstall } from '@/utils'
import Mask from './src/index.vue'
export default withInstall(Mask)
